package us.laantech.admin.menu.clients.ads.ui

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.Button
import androidx.compose.material3.Checkbox
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.TextField
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import us.laantech.admin.menu.clients.ads.LocalAdConfigViewModel
import us.laantech.admin.menu.clients.ads.s3FileName
import us.laantech.common.dto.company.AdTransition
import us.laantech.common.dto.company.PosAd
import us.laantech.common.ui.DropdownMenu

@Composable
fun SequenceCard(index: Int, posAd: PosAd) {

    val viewModel = LocalAdConfigViewModel.current
    val uiState by LocalAdConfigViewModel.current.uiState.collectAsStateWithLifecycle()

    val fileName = posAd.filename ?: return
    // posAd.filename holds only the bare file name; resolve it back to the full presigned
    // S3 URL so the preview fetches from S3 rather than the (non-existent) app-relative path.
    val s3Url = uiState.adFileUrls.find { s3FileName(it) == fileName } ?: return

    // Fill the panel width and let the height wrap the two rows; a fixed maxHeight squashed the
    // rows so they overlapped, and a fixed maxWidth pushed the Remove button off the edge.
    Surface(modifier = Modifier.fillMaxWidth().padding(4.dp), border = BorderStroke(1.dp, Color.Gray)) {

        Row {

            // Fixed small square. The size has to be enforced by this wrapping Box, not
            // by a modifier on S3Preview: the video branch (VideoPlayerSurface) hardcodes
            // its root to fillMaxSize and ignores the modifier's size, so it only shrinks
            // when the parent hands it bounded constraints. fillMaxSize inside then fills
            // this 64.dp box for both the image and video cases.
            Box(Modifier.size(64.dp).align(Alignment.CenterVertically)) {
                S3Preview(
                    s3Url,
                    Modifier.fillMaxSize(),
                    contentScale = ContentScale.Crop,
                )
            }

            Column(modifier = Modifier.fillMaxWidth().padding(4.dp)) {

                // Row 1: choose the transition and set the duration.
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.spacedBy(8.dp),
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    DropdownMenu(
                        label = "Transition",
                        items = AdTransition.entries,
                        selectedItem = posAd.transition,
                        itemLabel = { transition -> transition.name },
                        onItemSelected = { transition ->
                            viewModel.updateSegment(index) { it.copy(transition = transition) }
                        },
                        modifier = Modifier.weight(2f),
                    )
                    TextField(
                        value = posAd.durationSeconds?.toString() ?: "",
                        onValueChange = { text ->
                            viewModel.updateSegment(index) { it.copy(durationSeconds = text.toLongOrNull()) }
                        },
                        placeholder = { Text("duration") },
                        singleLine = true,
                        modifier = Modifier.weight(1f),
                    )
                }

                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.SpaceAround
                ) {
                    Checkbox(
                        checked = posAd.mute ?: true,
                        onCheckedChange = { checked ->
                            viewModel.updateSegment(index) { it.copy(mute = checked) }
                        }
                    )
                    Text(text = "Mute")

                    Button({
                        viewModel.removeSegment(posAd)
                    }, contentPadding = PaddingValues(horizontal = 4.dp, vertical = 4.dp)
                    ) {
                        Text(text = "Remove")
                    }
                    Button(
                        onClick = { viewModel.moveSegment(index, -1) },
                        enabled = index > 0,
                        contentPadding = PaddingValues(horizontal = 4.dp, vertical = 4.dp)
                    ) {
                        Text(text = "Up")
                    }
                    Button(
                        onClick = { viewModel.moveSegment(index, 1) },
                        enabled = index < uiState.adSequence.lastIndex,
                        contentPadding = PaddingValues(horizontal = 4.dp, vertical = 4.dp)
                    ) {
                        Text(text = "Dn")
                    }
                }

            }
        }
    }

}